import { render, staticRenderFns } from "./IconSpecimenRan.vue?vue&type=template&id=210b81ea"
import script from "./IconSpecimenRan.vue?vue&type=script&lang=js"
export * from "./IconSpecimenRan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports